import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect, useState } from "react"; // Import useState and useEffect
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
// import logo from "../assets/images/Logo Banc.png";
import logo from "../assets/images/logo.svg";
import useIsMobile from "../hooks/useIsMobile";
import { SignInButton } from "./Auth/SignInButton";
import { SignOutButton } from "./Auth/SignOutButton";
import styles from "./NavigationBar.module.scss"; // Import the styles

export const NavigationBar = () => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("");
  const isMobile = useIsMobile();

  useEffect(() => {
    // Set the active link based on the current path
    if (location.pathname.includes("/market")) {
      setActiveLink("market");
    } else if (location.pathname.includes("/mydeal")) {
      setActiveLink("mydeal");
    } else if (location.pathname.includes("/legal")) {
      setActiveLink("legal");
    } else if (location.pathname.includes("/oreima")) {
      setActiveLink("oreima");
    } else {
      setActiveLink("");
    }
  }, [location.pathname]);

  const handleLinkClick = (link: string) => {
    setActiveLink(link);
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:georges@infraviacapital.com";
  };

  const handleUserGuideClick = () => {
    window.open(
      "https://infraviacapital.sharepoint.com/:f:/r/sites/prd-team-Infravia-Toolbox-And-Procedures/IT/Georges%20AI?csf=1&web=1&e=0d68A2",
      "_blank"
    );
  };

  return (
    <Navbar
      expand="lg"
      className="bg-primary sticky-top"
      style={{ zIndex: 1000 }}
    >
      <Container fluid style={{ paddingLeft: "5%", paddingRight: "5%" }}>
        <Navbar.Brand href="/">
          <img
            src={logo}
            height={isMobile ? "30px" : "40px"}
            className="d-inline-block align-top"
            alt="eleven"
          />
        </Navbar.Brand>
        {isAuthenticated && activeLink !== "" && (
          <Nav
            className="mx-auto d-flex justify-content-center"
            style={{
              textTransform: "uppercase",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            <Nav.Link
              as={Link}
              to="/"
              className={`text-bg-primary me-4 ${styles.navLink} ${
                activeLink === "market" ? `${styles.active} fw-bold` : ""
              }`}
              onClick={() => setActiveLink("/")}
            >
              Back to main menu
            </Nav.Link>
          </Nav>
        )}
          
        {/* Buttons on the right */}
        <div className="d-flex align-items-center ms-auto">
          {/* User Guide Button (not on Mobile) */}
          {!isMobile && isAuthenticated && (<Button
            variant="link"
            className={`text-bg-primary me-4 nav-link`}
            onClick={handleUserGuideClick}
            style={{
              fontSize: "18px",
              // fontWeight: "bold",
              fontStyle: "italic",
              // textTransform: "uppercase",
              padding: 0,
            }}
          >
            Access our training material
          </Button>)}
          {/* Authenticated Button with margin */}
          <div style={{ marginLeft: "20px" }}>
            {" "}
            {/* Add margin here */}
            {isAuthenticated ? <SignOutButton /> : <SignInButton />}
          </div>
        </div>
      </Container>
    </Navbar>
  );
};
